import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

export class ComponentSubscribe {
    private readonly inputMessageId = '#hd-input__message';
    private readonly inputMessageClass = '.hd-input__message';
    private readonly confirmationElClass = '.hd-subscribe__confirmation';
    private readonly loadingElClass = '.hd-subscribe__loading';
    private readonly formContentElClass = '.hd-subscribe__form-content';

    private el: HTMLElement;
    private loadingEl: HTMLFormElement | null;
    private formEl: HTMLFormElement | null;
    private formSubmitEl: HTMLElement | null;
    private formContentEl: HTMLElement | null;
    private confirmationEl: HTMLElement | null;
    private formId;
    private loaderTimeout;

    private formSubmitFn;

    private isLoading = false;

    constructor(el: HTMLElement) {
        this.el = el;
        this.loadingEl = el.querySelector(this.loadingElClass);
        this.confirmationEl = el.querySelector(this.confirmationElClass);
        this.formContentEl = el.querySelector(this.formContentElClass);
        this.formEl = el.querySelector('form');
        this.formId = this.formEl && this.formEl.dataset['formid'];
        this.formSubmitEl = this.formEl && this.formEl.querySelector('button[type="submit"]');
    }

    public onInit() {
        if (this.formEl) {
            this.formSubmitFn = this.onFormSubmit.bind(this);
            this.formEl.addEventListener('submit', this.formSubmitFn);
        }
    }

    public onDestroy() {
        if (this.formEl && this.formSubmitFn) {
            this.formEl.removeEventListener('submit', this.formSubmitFn);
        }
    }

    private async onFormSubmit(e) {
        e.preventDefault();
        if (this.formEl) {
            const formData: FormData = new FormData(this.formEl);
            this.clearMessages();
            this.setLoading(true);
            const response = await this.postData(`/wp-json/gf/v2/forms/${this.formId}/submissions`, this.formDataToObject(formData));
            this.setLoading(false);
            this.handleResponse(response);
        }
    }

    private setLoading(state) {
        this.isLoading = state;
        if (!this.loadingEl) {
            return;
        }
        clearTimeout(this.loaderTimeout);
        if (state) {
            this.loadingEl.classList.remove('hidden');
            this.loaderTimeout = setTimeout(() => {
                this.loadingEl && this.loadingEl.classList.add('visible');
            }, 0);
        } else {
            this.loadingEl.classList.remove('visible');
            this.loaderTimeout = setTimeout(() => {
                this.loadingEl && this.loadingEl.classList.add('hidden');
            }, 350);
        }
    }

    private clearMessages() {
        if (!this.formEl) {
            return;
        }
        const messages = Array.from(this.formEl.querySelectorAll(this.inputMessageClass));
        messages.forEach(messageEl => {
            messageEl.innerHTML = '';
        });
    }

    private handleResponse(response) {
        if (response.is_valid) {
            this.handleSuccessResponse(response);
        } else {
            this.handleErrorResponse(response);
        }
    }

    private handleSuccessResponse(response) {
        if (!this.confirmationEl) {
            return;
        }
        if (this.formContentEl) {
            this.formContentEl.remove();
        }
        this.confirmationEl.innerHTML = response.confirmation_message;
    }

    private getInputMessageId(inputId) {
        return `${this.inputMessageId}_${this.formId}_${inputId}`;
    }

    private handleErrorResponse(response) {
        if (!this.formEl) {
            return;
        }
        if (response.validation_messages) {
            for (const [key, value] of Object.entries(response.validation_messages)) {
                const el: HTMLElement | null = this.formEl.querySelector(this.getInputMessageId(key));
                if (!el) {
                    return;
                }
                el.innerHTML = <string>value;
            }
        }
    }

    private formDataToObject(formData: FormData) {
        const object = {};
        formData.forEach((value, key) => {
            object[key] = value
        });
        return object;
    }

    private async postData(url = '', formObject = {}) {
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
            },
            redirect: 'follow', // manual, *follow, error
            body: JSON.stringify(formObject) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }


}

export function useComponentSubscribe() {
    useEventBus('hd-subscribe', ComponentSubscribe);
}